<template>
  <div>
    <NewsDetailsMobile v-if="isMobile" :newDet="newDet" />
    <div v-else class="news-details">
      <!-- 将 breadcrumb 移到 main-content 上方 -->
      <div class="news-details-wrapper">
        <div class="breadcrumb">
          <span
            class="breadcrumb-all"
            @click="
              () => {
                $router.push('/news_center');
              }
            "
            >{{ tabLabel }}</span
          >
          <span class="breadcrumb-sep">/</span>
          <span class="breadcrumb-detail">新闻详情</span>
        </div>
        <div class="main-body">
          <div class="main-content">
            <h1 class="news-title">{{ newDet.title }}</h1>
            <div class="news-meta">
              <div>
                <span class="news-source">{{ newDet.newspaper }} | </span>
                <span class="news-time">{{ newDet.time }}</span>
              </div>
              <span class="news-views">浏览：{{ newDet.pageView }}次</span>
            </div>

            <!-- <div class="news-content">
                            <p v-for="(para, idx) in paragraphs" :key="idx">{{ para }}</p>
                        </div> -->
            <div class="news-content" v-html="richContent"></div>
            <!-- 图片轮播图开始 -->
            <div v-if="imgList.length" class="news-vertical-list">
              <div
                v-for="(img, idx) in imgList"
                :key="idx"
                class="vertical-img-wrapper"
                :style="{
                  marginBottom: idx !== imgList.length - 1 ? '20PX' : '0',
                }"
              >
                <img :src="img" alt="news image" class="news-image" />
              </div>
            </div>

            <!-- 视频竖排排列开始（支持一个或多个，逗号分隔） -->
            <div
              v-if="videoList.length"
              class="news-vertical-list news-video-list"
            >
              <div
                v-for="(video, idx) in videoList"
                :key="'vid-' + idx"
                class="vertical-video-wrapper"
                :style="{
                  marginBottom: idx !== videoList.length - 1 ? '20PX' : '0',
                }"
              >
                <video
                  controls
                  :src="video"
                  class="news-video"
                  preload="metadata"
                ></video>
              </div>
            </div>
            <!-- 视频竖排排列结束 -->
            <p class="news-author">
              <span class="author-reporter">{{ newDet.reporter }}</span>
              <span>{{ newDet.correspondent }}</span>
            </p>
          </div>
          <div class="sidebar">
            <h2 class="sidebar-title">热点精选</h2>
            <ul class="hot-list">
              <li
                v-for="(item, index) in hotList"
                :key="index"
                class="hot-item"
                @click="selectNews(item.id)"
                style="cursor: pointer"
              >
                <img
                  :src="getFirstImage(item)"
                  alt="hot image"
                  class="hot-image"
                />
                <!-- <img :src="(item.img ? item.img.split(',')[0] : '')" alt="hot image" class="hot-image" /> -->
                <div class="hot-title-custom">{{ item.title }}</div>
                <div class="hot-info">
                  <p class="hot-title">{{ item.time }}</p>
                  <p class="hot-time">浏览量：{{ item.pageView }}次</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsDetailsMobile from "./NewsDetailsMobile.vue";
import { listByTYpe } from "@/api/news.js";
import { IMG_BASE_URL } from "@/utils/index.js";
import router from "@/router";

export default {
  components: {
    NewsDetailsMobile,
  },
  props: {
    newDet: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      router,
      newsItems: [],
      currentImg: 0,
      tabLabel: "", // 新增 tabLabel
      isMobile: window.innerWidth <= 992, // 判断是否为移动端
    };
  },
  computed: {
    paragraphs() {
      // 按 \r\n 分割内容，过滤掉空行
      return this.newDet.content
        ? this.newDet.content.split(/\n/).filter((p) => p.trim())
        : [];
    },
    richContent() {
      // 处理富文本内容，确保图片路径正确
      if (!this.newDet.content) return "";

      let content = this.newDet.content;

      // 处理转义的HTML标签
      content = content
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");

      // 处理vue-quill生成的富文本内容
      // 移除ql-container和ql-editor包装，但保留内部内容的class属性
      content = content.replace(
        /<div class="ql-container.*?>(.*?)<\/div>/gs,
        "$1",
      );
      content = content.replace(
        /<div class="ql-editor.*?>(.*?)<\/div>/gs,
        "$1",
      );

      // 处理特殊格式的图片标记，如 ![image.png](data:image/png;base64,...)
      content = content.replace(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/gi,
        '<img src="$2" alt="$1" class="news-content-image" />',
      );

      // 处理Markdown格式
      // 加粗
      content = content.replace(/\*\*(.*?)\*\*/gi, "<strong>$1</strong>");
      // 斜体
      content = content.replace(/\*(.*?)\*/gi, "<em>$1</em>");
      // 删除线
      content = content.replace(/~~(.*?)~~/gi, "<del>$1</del>");
      // 标题 - 支持#后面有或没有空格的情况
      content = content.replace(/^#{1}\s*(.*?)$/gm, "<h1>$1</h1>");
      content = content.replace(/^#{2}\s*(.*?)$/gm, "<h2>$1</h2>");
      content = content.replace(/^#{3}\s*(.*?)$/gm, "<h3>$1</h3>");
      // 无序列表
      content = content.replace(/^\*\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ul>$1</ul>");
      // 有序列表
      content = content.replace(/^\d+\.\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ol>$1</ol>");
      // 段落 - 保留原始的class属性
      content = content.replace(/^(?!<h|!<|\*|\d+\.)(.*?)$/gm, (match) => {
        // 检查是否已经有HTML标签
        if (/^<.*?>/.test(match)) {
          return match;
        }
        return "<p>" + match + "</p>";
      });

      // 将\n转换为<br>标签，实现换行效果
      content = content.replace(/\n/g, "<br>");

      // 如果存在IMG_BASE_URL，并且图片路径是相对路径，则拼接完整URL
      if (this.IMG_BASE_URL) {
        // 匹配<img>标签中的src属性，保留其他属性如class
        content = content.replace(
          /<img\s+(.*?)src="([^"]+)"(.*?)>/gi,
          (match, prefix, src, suffix) => {
            // 检查是否已经是完整URL或base64
            if (!/^https?:\/\//i.test(src) && !src.startsWith("data:")) {
              // 拼接完整URL
              return (
                "<img " +
                prefix +
                'src="' +
                this.IMG_BASE_URL +
                src +
                '"' +
                suffix +
                ">"
              );
            }
            return match;
          },
        );
      }

      return content;
    },
    imgList() {
      // 按逗号分割图片字符串，过滤空字符串
      return this.newDet.img
        ? this.newDet.img
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : [];
    },
    // 新增：解析 video 字段，逗号分隔；若非绝对地址则拼接 IMG_BASE_URL
    videoList() {
      const raw = this.newDet.video || "";
      const list = raw
        ? raw
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean)
        : [];
      return list.map((v) => {
        if (/^https?:\/\//i.test(v)) return v;
        return this.IMG_BASE_URL ? this.IMG_BASE_URL + v : v;
      });
    },
    hotList() {
      // 返回newsItems的前三条
      return this.newsItems.slice(0, 3);
    },
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    },
  },
  methods: {
    prevImg() {
      if (this.currentImg > 0) {
        this.currentImg--;
      }
    },
    getFirstImage(news) {
      // 首先检查news.img字段是否有图片
      if (news.img && news.img.trim() !== "") {
        return news.img.split(",")[0];
      }

      // 如果没有，再从富文本中提取第一个图片
      const content = news.content;
      if (!content) return "";

      // 匹配<img>标签中的src属性
      const imgTagMatch = content.match(/<img\s+src="([^"]+)"/i);
      if (imgTagMatch && imgTagMatch[1]) {
        return imgTagMatch[1];
      }

      // 匹配Markdown格式的图片
      const markdownMatch = content.match(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/i,
      );
      if (markdownMatch && markdownMatch[2]) {
        return markdownMatch[2];
      }

      return "";
    },
    nextImg() {
      if (this.currentImg < this.imgList.length - 1) {
        this.currentImg++;
      }
    },
    getNews() {
      listByTYpe({ type: 1 }).then((res) => {
        if (res) {
          this.newsItems = res.result;
        }
      });
    },
    selectNews(id) {
      // 跳转时带上tab label参数
      this.$router.push({
        path: "/news_detail",
        query: {
          source: id,
          tabLabel: this.tabLabel,
        },
      });
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 992;
    },
  },
  watch: {
    imgList() {
      // 图片列表变化时重置索引
      this.currentImg = 0;
    },
  },
  mounted() {
    this.getNews();
    this.tabLabel =
      new URLSearchParams(window.location.search).get("tabLabel") || "";
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.news-details {
  font-family: PingFang SC;
  display: flex;
  gap: 20px;
  // padding: 0PX 18.75%;
  padding-top: 120px;
  background: #fbfbfb;
  @media screen and (max-width: 768px) {
    padding-top: 0px;
  }
  .news-details-wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  // breadcrumb 绝对定位
  .breadcrumb {
    // position: absolute;
    // top: 120PX; // 根据实际页面调整
    // left: 18.75%;
    z-index: 10;
    // margin-bottom: 50PX;
    font-size: 16px;
    display: flex;
    align-items: center;
    font-family: PingFang SC;

    .breadcrumb-all {
      color: #c2c6cc;

      cursor: pointer;
    }

    .breadcrumb-sep {
      color: #c2c6cc;
      margin: 0 8px;
    }

    .breadcrumb-detail {
      color: #1e242a;
    }
  }

  .main-body {
    display: flex;
    gap: 20px;
  }
  .main-content {
    width: calc(100% - 340px); // 左侧宽度自适应
    // padding-right: 20PX;
    background-color: #fff;
    border-radius: 10px;
    padding: 40px;
    margin-bottom: 80px;
    margin-top: 39px;

    .news-title {
      font-size: 32px;
      font-weight: bold;
      color: #1e242a;
    }

    .news-meta {
      font-size: 14px;
      text-align: left;
      color: #1e242a;
      opacity: 0.4;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      span {
        margin-right: 10px;
      }

      border-bottom: 1.5px solid #e1e6f0;
      padding-bottom: 16px;
    }

    .news-content {
      font-size: 1rem;
      line-height: 1.8;
      margin-bottom: 20px;
      margin-top: 20px;

      p {
        text-indent: 2em;
        margin-bottom: 1em;
        font-family: PingFang SC;
        font-size: 16px;

        color: #1e242a;
      }

      .news-content-image {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 8px;
      }

      /* 富文本样式 - 使用深度选择器确保应用到v-html内容 */
      ::v-deep strong {
        font-weight: bold;
      }

      ::v-deep em {
        font-style: italic;
      }

      ::v-deep del {
        text-decoration: line-through;
      }

      ::v-deep h1,
      ::v-deep h2,
      ::v-deep h3 {
        margin: 1em 0;
        font-weight: bold;
      }

      ::v-deep h1 {
        font-size: 24px;
      }

      ::v-deep h2 {
        font-size: 20px;
      }

      ::v-deep h3 {
        font-size: 18px;
      }

      ::v-deep ul,
      ::v-deep ol {
        margin: 1em 0;
        padding-left: 2em;
      }

      ::v-deep li {
        margin: 0.5em 0;
      }

      /* vue-quill 样式 - 使用深度选择器 */
      ::v-deep .ql-align-center {
        text-align: center;
      }

      ::v-deep .ql-align-right {
        text-align: right;
      }

      ::v-deep .ql-align-justify {
        text-align: justify;
      }

      ::v-deep .ql-size-small {
        font-size: 0.8em;
      }

      ::v-deep .ql-size-large {
        font-size: 1.2em;
      }

      ::v-deep .ql-size-huge {
        font-size: 1.5em;
      }
    }

    .news-author {
      font-family: PingFang SC;
      font-size: 13px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #1e242a;
      margin-top: 30px;

      .author-reporter {
        margin-right: 20px;
        word-break: break-all;
      }
    }

    .news-carousel {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      margin: 20px 0;

      .carousel-img-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .carousel-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
          background: rgba(255, 255, 255, 0.8);
          border: 1px solid #ccc;
          border-radius: 50%;
          width: 32px;
          height: 32px;
          font-size: 18px;
          cursor: pointer;
          margin: 0;

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }

        .carousel-btn.left {
          left: 10px;
        }

        .carousel-btn.right {
          right: 10px;
        }

        .news-image {
          width: 100%;
          object-fit: cover;
          border-radius: 8px;
          display: block;
        }
      }

      .carousel-indicator {
        position: absolute;
        bottom: 8px;
        right: 16px;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 2px 8px;
        border-radius: 10px;
        font-size: 12px;
      }
    }

    .news-vertical-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0;

      .vertical-img-wrapper {
        width: 100%;

        .news-image {
          width: 100%;
          object-fit: cover;
          border-radius: 8px;
          display: block;
        }
      }
    }

    /* 视频样式 */
    .news-video-list {
      .vertical-video-wrapper {
        width: 100%;

        .news-video {
          width: 100%;
          max-height: 480px;
          background: #000;
          border-radius: 8px;
          display: block;
        }
      }
    }
  }

  .sidebar {
    width: 348px; // 右侧固定宽度
    // background-color: #fff;
    // padding: 24PX;
    margin-bottom: 20px;
    margin-top: 39px;

    .sidebar-title {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1e242a;
      background-color: #fff;
      padding: 24px;
      padding-bottom: 0px;
    }

    .hot-list {
      list-style: none;
      padding: 24px;
      background-color: #fff;
      padding-bottom: 1px;

      .hot-item {
        display: block; // 由 flex 改为 block，使图片和信息换行显示
        margin-bottom: 24px;

        .hot-image {
          // width: 80PX;
          // height: 80PX;
          width: 100%;
          object-fit: cover;
          border-radius: 8px;
          margin-right: 0; // 取消右边距
          margin-bottom: 16px; // 图片和信息之间增加下边距
          display: block; // 保证图片独占一行
          height: 194px;
        }

        .hot-title-custom {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: bold;
          line-height: normal;
          letter-spacing: normal;
          color: #1e242a;
          margin-bottom: 8px;
          white-space: nowrap; // 不换行
          overflow: hidden; // 超出隐藏
          text-overflow: ellipsis; // 超出显示省略号
          max-width: 100%; // 限制最大宽度为容器宽度
          display: block; // 保证块级显示
        }

        .hot-info {
          display: flex;
          justify-content: space-between;

          .hot-title {
            font-family: PingFang SC;
            font-size: 12px;
            opacity: 0.6;
            line-height: normal;
            letter-spacing: normal;
            color: #1e242a;
            margin-bottom: 5px;
          }

          .hot-time {
            color: #1e242a;
            font-size: 12px;
            opacity: 0.6;
            font-weight: normal;
            line-height: normal;
            letter-spacing: normal;
          }
        }
      }
    }
  }
}
</style>
